import axios from "axios";
import { url } from "../baseUrl";

export const ReportFindingStore = {
  state: {},
  mutations: {},
  actions: {
    deleteDetailFinding(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/configuration/analysisdetails/" + data.id + "/",
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "DELETE"
        })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    updateDetailFinding(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/configuration/analysisdetails/" + data.id + "/",
          headers: {
            Authorization: "Token " + auth_token
          },
          data: data,
          method: "PUT"
        })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    downloadReport(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/configuration/downloadreport/?id=" + data.id,
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "GET",
          responseType: "arraybuffer"
        })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
